<template>
  <div class="intro" id="intro">
    <HeroTitle v-scroll-reveal.reset />
    <div class="profile" id="#profile">
      <img
        class="profile-pic"
        src="./../assets/profile.jpeg"
        v-scroll-reveal.reset="{ delay: 250 }"
      />
      <Social id="social" v-scroll-reveal.reset="{ delay: 500 }" />
    </div>
  </div>
</template>

<script>
  import HeroTitle from './HeroTitle'
  import Social from './../components/Social'
  export default {
    components: {
      HeroTitle,
      Social
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .intro {
    z-index: 2;
    min-height: 100vh;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 100%;
    display: flex;
    flex-flow: column;
    flex: 100%;
  }

  .profile {
    padding: 1rem;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .profile-pic {
      margin-top: 1rem;
      border-radius: 50%;
      width: 15rem;
      height: 15rem;
    }
  }
  @media screen and (min-height: 500px) {
    .intro {
      justify-content: center;
    }
  }
</style>
